import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import PersonIcon from "@mui/icons-material/Person";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import FavoriteIcon from "@mui/icons-material/Favorite";
import LogoutIcon from "@mui/icons-material/Logout";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { clearUser } from "../../../../Store/Slices/reducer";
import { clearFullCart } from "../../../../Store/Slices/CartSlice/cartSlice";

export default function ProfileTabs() {
  const dispatch = useDispatch();
  const theme = useTheme();
  const location = useLocation().pathname;
  const navigate = useNavigate();

  const [openAlert, setOpenAlert] = useState(false);

  const items = [
    {
      name: "پروفایل",
      path: "/profile",
      icon: <PersonIcon sx={{ color: "inherit", fontSize: "1.5rem" }} />,
    },
    {
      name: "سفارشات و تراکنش‌ها",
      path: "/profile/orders",
      icon: <ReceiptLongIcon sx={{ color: "inherit", fontSize: "1.5rem" }} />,
    },
    {
      name: "لیست علاقمندی",
      path: "/profile/favorites",
      icon: <FavoriteIcon sx={{ color: "inherit", fontSize: "1.5rem" }} />,
    },
    {
      name: "خروج",
      path: "out",
      icon: <LogoutIcon sx={{ color: "inherit", fontSize: "1.5rem" }} />,
    },
  ];
  const Logout = () => {
    dispatch(clearUser());
    dispatch(clearFullCart());
    navigate("/");
    setOpenAlert(false);
    toast.success("با موفقیت خارج شدید");
  };
  const showItems = items.map((item, index) => {
    return (
      <Stack
        direction={"row-reverse"}
        sx={{
          cursor: "pointer",
          transition: "all .3s",
          position: "relative",
          alignItems: "center",
          gap: ".5rem",
          color:
            location == item.path
              ? theme.palette.primary.main
              : theme.palette.primary.lowOpacity,
        }}
        onClick={() =>
          item?.path == "out" ? setOpenAlert(true) : navigate(item?.path)
        }
        key={index}
      >
        <Typography
          sx={{
            transition: "all .1s",
            color:
              location == item.path
                ? theme.palette.primary.main
                : theme.palette.primary.lowOpacity,
            fontWeight: location == item.path ? "bold" : "normal",
            fontSize: {
              xs: "1rem",
              md: "1rem",
              lg: "1.15rem",
              xxl: "1.25rem",
            },
          }}
        >
          {item?.name}
        </Typography>
        {item?.icon}
      </Stack>
    );
  });
  return (
    <>
      <Stack
        direction={"row"}
        sx={{
          maxWidth: "1050px",
          px: "3rem",
          width: "100%",
          mx: "auto",
          justifyContent: "space-between",
          gap: "2rem",
          direction: "rtl",
          flexWrap: "wrap",
          rowGap: "2.5rem",
        }}
      >
        {showItems}
      </Stack>
      <Dialog
        sx={{}}
        PaperProps={{
          sx: {
            color: theme.palette.primary.main,
            bgcolor: theme.palette.background.lightCream,
            borderRadius: "16px",
            width: "350px",
            height: "180px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            border: `3px solid ${theme.palette.primary.main}`,
          },
        }}
        open={openAlert}
        onClose={() => setOpenAlert(false)}
      >
        <DialogTitle
          sx={{ fontSize: "1.2rem", color: theme.palette.primary.main }}
        >
          آیا از خروج مطمئن هستید؟
        </DialogTitle>
        <DialogActions>
          <Button
            onClick={() => Logout()}
            sx={{
              fontSize: "1rem",
              color: theme.palette.secondary.main,
              bgcolor: theme.palette.primary.main,
              mx: ".5rem",
            }}
            variant="contained"
          >
            بله
          </Button>
          <Button
            variant="outlined"
            onClick={() => setOpenAlert(false)}
            sx={{
              fontSize: "1rem",
              color: theme.palette.primary.main,
            }}
          >
            انصراف
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
